import React from 'react';
import { Select } from 'antd';
import { useArtifactTypes } from '../../../hooks/useArtifactTypes';

const { Option } = Select;

export interface ArtifactTypeSelectorProps {
  value?: string;
  onChange: (typeId: string) => void;
  placeholder?: string;
  disabled?: boolean;
  style?: React.CSSProperties;
  allowClear?: boolean;
  showSearch?: boolean;
  className?: string;
  size?: 'small' | 'middle' | 'large';
}

export const ArtifactTypeSelector: React.FC<ArtifactTypeSelectorProps> = ({
  value,
  onChange,
  placeholder = 'Select artifact type',
  disabled = false,
  style = {},
  allowClear = true,
  showSearch = true,
  className,
  size = 'middle',
}) => {
  const { artifactTypes, loading, error } = useArtifactTypes();

  const handleChange = (selectedValue: string) => {
    onChange(selectedValue || '');
  };

  if (error) {
    return (
      <div
        style={{
          padding: '8px 12px',
          border: '1px solid #fca5a5',
          borderRadius: '6px',
          backgroundColor: '#fef2f2',
          color: '#dc2626',
          fontSize: '14px',
          ...style,
        }}
      >
        Failed to load artifact types
      </div>
    );
  }

  return (
    <Select
      value={value || undefined}
      onChange={handleChange}
      disabled={disabled}
      loading={loading}
      placeholder={loading ? 'Loading types...' : placeholder}
      allowClear={allowClear}
      showSearch={showSearch}
      filterOption={(input, option) => {
        const label = typeof option?.label === 'string' 
          ? option.label 
          : (typeof option?.children === 'string' 
            ? option.children 
            : String(option?.label || option?.children || ''));
        return label.toLowerCase().includes(input.toLowerCase());
      }}
      style={style}
      className={className}
      size={size}
    >
      {artifactTypes.map((type) => (
        <Option key={type.id} value={type.id}>
          {type.name}
        </Option>
      ))}
    </Select>
  );
};
